import { useQuery } from '@tanstack/react-query';
import { logsApi } from '@/features/logs/api';
import type { LogQuery } from '@/features/logs/types';

export const useLogSearch = (q: LogQuery, enabled: boolean) =>
  useQuery({ queryKey: ['logs', q], queryFn: () => logsApi.search(q), enabled, staleTime: 10_000 });
